module.exports = __webpack_public_path__ + "static/media/204-guernsey.c1f9c050.svg";